export const configStaffAreasInspectors = [
	{
		"id": "cad00875-0a6b-4836-9754-aad5ce48256e",
		"displayName": "desexing_tl1",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "ca09113a-88ee-436d-90e7-ce3aca37ed45",
		"displayName": "desexing_tl2",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "fde8ea14-5544-4897-828e-6aae496802c5",
		"displayName": "desexing_tl3",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "ce0f441f-1147-4ed4-af1e-9ec7c2dd9a4d",
		"displayName": "desexing_tl4",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "d2686094-400f-4626-8f78-8526ce444658",
		"displayName": "desexing_tl5",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "52fbb9c8-a3a0-4d5b-94c4-d04aecf869f3",
		"displayName": "desexing_tl6",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "a8f6a700-7c16-46e2-b885-6cdc383586c2",
		"displayName": "desexing_tl7",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "08cb735c-0037-4aed-9260-d37081848f34",
		"displayName": "desexing_tl8",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "72c3cdc7-9da4-4c37-a878-b42ed2e60c1f",
		"displayName": "desexing_tl9",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "706e8ec7-c08c-4fbc-a9df-176fcc96f1b7",
		"displayName": "desexing_n1",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "81f48109-a528-4c50-8ecc-a8f6f7cc3681",
		"displayName": "desexing_n2",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "ed4fff4f-8a58-4d2a-adf8-85ee2385cd05",
		"displayName": "desexing_n3",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "033ab13e-c9d6-46a5-844d-0fa9ea60ff2c",
		"displayName": "desexing_s1",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "c5af1bc4-0f71-44d7-9d27-838b8e352de9",
		"displayName": "desexing_s2",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	},
	{
		"id": "555aa5af-de90-4757-bc6d-879b3b15c05d",
		"displayName": "desexing_s3",
		"groupType": "Security",
		"membershipType": "Assigned",
		"source": "Cloud",
		"mail": "",
		"securityEnabled": "TRUE",
		"mailEnabled": "FALSE",
		"isAssignableToRole": "FALSE",
		"onPremisesSyncEnabled": ""
	}
];